/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import { PropTypes } from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core';
import { TestNativeFeatures } from '../../components';
import styles from './styles';
import LoggedIn from '../loggedIn/loggedIn';

// sample layout, change this as per your app's need
const AppLayout = ({
  classes: { header, header_link, content, layoutContainer, footer, user_SignIn },
  t,
}) => {
  const testNativeFeatures = process.env.REACT_APP_TEST_NATIVE_FEATURES === 'yes';

  return (
    <React.Fragment>
      <div className={layoutContainer}>
        <div className={content}>
          <span className={user_SignIn}>
            <LoggedIn />
          </span>
        </div>
        {testNativeFeatures && (
          <div className={footer}>
            <TestNativeFeatures />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

AppLayout.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(AppLayout));
